var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-edit-form-container"},[(_vm.isShow)?_c('material-box',_vm._b({ref:"material_box_ref",attrs:{"advertiser":_vm.channel_interface,"is-open":_vm.isShow},on:{"confirm":_vm.materialConfirm,"cancel":_vm.materialCancel,"hook:mounted":_vm.onMaterialBoxMounted}},'material-box',_vm.material_box_props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }